/**
 * Firebase (Auth only). Config from env: REACT_APP_FIREBASE_*
 * See docs/SETUP.md for setting these in .env.local.
 *
 * Create React App inlines REACT_APP_* at **build** time. If vars are missing during
 * `npm run build` (e.g. on Vercel), they stay empty until you redeploy after adding them.
 */
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

function trimEnv(value) {
  if (value == null) return '';
  const s = String(value).trim();
  return s;
}

// Explicit reads so CRA/webpack can inline each var at build time (dynamic process.env[key] does not work).
const apiKey = trimEnv(process.env.REACT_APP_FIREBASE_API_KEY) || undefined;
const authDomain = trimEnv(process.env.REACT_APP_FIREBASE_AUTH_DOMAIN) || undefined;
const projectId = trimEnv(process.env.REACT_APP_FIREBASE_PROJECT_ID) || undefined;
const storageBucket = trimEnv(process.env.REACT_APP_FIREBASE_STORAGE_BUCKET) || undefined;
const messagingSenderId = trimEnv(process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID) || undefined;
const appId = trimEnv(process.env.REACT_APP_FIREBASE_APP_ID) || undefined;

/** Which expected env keys are empty in this build (helps debug Vercel / local). */
export const missingFirebaseEnvVars = [
  !apiKey && 'REACT_APP_FIREBASE_API_KEY',
  !authDomain && 'REACT_APP_FIREBASE_AUTH_DOMAIN',
  !projectId && 'REACT_APP_FIREBASE_PROJECT_ID',
  !storageBucket && 'REACT_APP_FIREBASE_STORAGE_BUCKET',
  !messagingSenderId && 'REACT_APP_FIREBASE_MESSAGING_SENDER_ID',
  !appId && 'REACT_APP_FIREBASE_APP_ID',
].filter(Boolean);

const config = {
  apiKey,
  authDomain,
  projectId,
  storageBucket,
  messagingSenderId,
  appId,
};

let app = null;
let authInstance = null;

if (config.apiKey && config.projectId) {
  app = initializeApp(config);
  authInstance = getAuth(app);
}

export const auth = authInstance;
export const GoogleAuthProviderClass = GoogleAuthProvider;
export const isFirebaseConfigured = Boolean(authInstance);
